/* Ürün sayfası: "Rutinini tamamla" — seçilen ürünler kendi butonuyla sepete eklenir (ana formdan bağımsız) */
(function () {
  if (window.__dedeRoutine) { window.__dedeRoutine(); return; }

  /* ---------- para biçimi ---------- */
  function formatMoney(cents, root) {
    var currency = root.getAttribute('data-currency'), shopCurrency = root.getAttribute('data-shop-currency');
    var fmt = root.getAttribute('data-money-format') || '';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (m && (!currency || currency === shopCurrency)) {
      var cfg = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_space_separator: [2, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.']
      }[m[1]];
      if (cfg) {
        var parts = (cents / 100).toFixed(cfg[0]).split('.');
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, cfg[1]);
        return fmt.replace(m[0], whole + (parts[1] ? cfg[2] + parts[1] : ''));
      }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr', { style: 'currency', currency: currency || shopCurrency || 'TRY' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ---------- rutinini tamamla ---------- */
  function initRoutine(root) {
    if (root._rt) return;
    root._rt = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rt-card]'));
    var btn = root.querySelector('[data-rt-add]');
    var label = root.querySelector('[data-rt-label]');
    var status = root.querySelector('[data-rt-status]');
    var live = root.querySelector('[data-rt-live]');
    if (!btn || !cards.length) return;
    var busy = false, addedTimer = null, ready = false;

    /* kartın varyantı her zaman açılır menüde görünen seçenekten okunur */
    function variantOf(c) {
      var sel = c.querySelector('[data-rt-variant]');
      var o = sel && sel.options[sel.selectedIndex];
      if (o && !o.disabled) return { id: o.value, cents: parseInt(o.getAttribute('data-cents'), 10) || 0, price: o.getAttribute('data-price') || '' };
      return { id: c.getAttribute('data-id'), cents: parseInt(c.getAttribute('data-cents'), 10) || 0, price: null };
    }

    var hint = root.querySelector('[data-rt-hint]');
    function selected() {
      return cards.filter(function (c) {
        var ch = c.querySelector('[data-rt-check]');
        return ch && ch.checked && !ch.disabled;
      });
    }
    function paint() {
      var list = selected(), total = 0;
      /* seçim sınırı: sınıra ulaşılınca seçili olmayan kartlar kilitlenir */
      var max = parseInt(root.getAttribute('data-max'), 10) || 0;
      /* sınırın üstünde işaretli kutu varsa (preselect ya da dışarıdan) fazlası temizlenir;
         kilitli kutular da sayılır, yoksa aşağıdaki kilit döngüsü onları yeniden açardı */
      if (max > 0) {
        var marked = cards.filter(function (c) {
          var x = c.querySelector('[data-rt-check]');
          return x && x.checked;
        });
        if (marked.length > max) {
          marked.slice(max).forEach(function (c) { c.querySelector('[data-rt-check]').checked = false; });
          list = selected();
        }
      }
      var full = max > 0 && list.length >= max;
      cards.forEach(function (c) {
        var ch = c.querySelector('[data-rt-check]');
        c.classList.toggle('is-selected', !!(ch && ch.checked));
        if (ch) {
          var lock = full && !ch.checked;
          if (ch.disabled !== lock) ch.disabled = lock;
          c.classList.toggle('is-locked', lock);
        }
      });
      list.forEach(function (c) { total += variantOf(c).cents; });
      btn.disabled = !list.length;
      btn.classList.remove('is-added');
      if (!list.length) {
        label.textContent = btn.getAttribute('data-empty-label');
      } else {
        label.textContent = '';
        label.appendChild(document.createTextNode(btn.getAttribute('data-label') + (list.length > 1 ? ' (' + list.length + ')' : '') + ' · '));
        var sum = document.createElement('span');
        sum.className = 'rt__sum';
        sum.textContent = formatMoney(total, root);
        label.appendChild(sum);
      }
      if (hint) {
        hint.textContent = max > 0 ? (full ? 'En fazla ' + max + ' ürün seçebilirsiniz.' : 'En fazla ' + max + ' ürün seçebilirsiniz (' + list.length + '/' + max + ').') : '';
        hint.hidden = max < 1;
      }
      if (live && ready) {
        live.textContent = list.length ? list.length + ' ürün seçildi, toplam ' + formatMoney(total, root) : 'Seçili ürün yok';
      }
    }
    function say(text, isError, withLink) {
      if (!status) return;
      status.classList.toggle('is-error', !!isError);
      status.textContent = text;
      if (withLink) {
        var a = document.createElement('a');
        a.href = root.getAttribute('data-cart-url') || '/cart';
        a.textContent = 'Sepete git';
        status.appendChild(document.createTextNode(' '));
        status.appendChild(a);
      }
    }

    cards.forEach(function (card) {
      var ch = card.querySelector('[data-rt-check]');
      var sel = card.querySelector('[data-rt-variant]');
      var price = card.querySelector('[data-rt-price]');
      if (ch) ch.addEventListener('change', function () { say(''); paint(); });
      function sync() {
        var v = variantOf(card);
        card.setAttribute('data-id', v.id);
        card.setAttribute('data-cents', String(v.cents));
        if (price && v.price !== null) price.textContent = v.price;
      }
      if (sel) {
        /* geri gelince tarayıcı eski seçimi bırakabilir */
        sync();
        sel.addEventListener('change', function () {
          sync();
          if (ch && !ch.disabled && !ch.checked) ch.checked = true;
          say('');
          paint();
        });
      }
      /* kartın boş bir yerine tıklamak seçimi değiştirir */
      card.addEventListener('click', function (e) {
        if (!ch || ch.disabled) return;
        if (e.target.closest('input, select, option, label, a, button')) return;
        ch.checked = !ch.checked;
        ch.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    btn.addEventListener('click', function () {
      var list = selected();
      if (!list.length || busy) return;
      busy = true;
      /* aria-disabled: odak butonda kalsın */
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var pl = root.getAttribute('data-prop-label'), pv = root.getAttribute('data-prop-value') || '';
      var items = list.map(function (c) {
        var it = { id: parseInt(variantOf(c).id, 10), quantity: 1 };
        /* siparişte/sepette görünen not: hangi ürünün rutininden geldiği */
        if (pl) { it.properties = {}; it.properties[pl] = pv; }
        return it;
      });
      var url = (root.getAttribute('data-add-url') || '/cart/add').split('?')[0].replace(/\/$/, '') + '.js';

      function finish() {
        busy = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-disabled');
        paint();
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.text().then(function (t) {
            var j = null;
            try { j = JSON.parse(t); } catch (err) { j = null; }
            return { ok: r.ok, j: j };
          });
        })
        .then(function (res) {
          if (!res.ok || !res.j) {
            finish();
            say((res.j && (res.j.description || res.j.message)) || 'Ürünler sepete eklenemedi. Lütfen tekrar deneyin.', true);
            return;
          }
          document.dispatchEvent(new CustomEvent('dede:cart:added', { detail: res.j }));
          if (root.getAttribute('data-after') === 'cart') {
            /* buton kilitli kalsın, tekrar eklemesin */
            window.location.href = root.getAttribute('data-cart-url') || '/cart';
            return;
          }
          finish();
          btn.classList.add('is-added');
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
          say(list.length > 1 ? list.length + ' ürün sepete eklendi.' : 'Sepete eklendi.', false, true);
        }, function () {
          finish();
          say('Bağlantı hatası. Lütfen tekrar deneyin.', true);
        });
    });

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !busy) return;
      busy = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
      paint();
    });

    paint();
    ready = true;
  }

  function init(scope) {
    scope = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-routine]'), initRoutine);
  }

  window.__dedeRoutine = function () { init(document); };
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
